//综合业务查询
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var SynthesizeQueryService = /** @class */ (function () {
    function SynthesizeQueryService() {
    }
    /**
     * 查询案件流转记录
     */
    SynthesizeQueryService.prototype.queryCaseTurnRecord = function (data, page, sort) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.queryCaseTurnRecord,
            data: {
                caseNumber: data.caseNumber,
                turnSource: data.turnSource,
                turnType: data.turnType,
                lastCollectorName: data.lastCollectorName,
                currentCollectorName: data.currentCollectorName,
                caseTurnTimeMin: FilterService.dateRanageFormat(data.caseTurnTime).start,
                caseTurnTimeMax: FilterService.dateRanageFormat(data.caseTurnTime).end,
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 委外案件查询
     */
    SynthesizeQueryService.prototype.queryCaseOutRecords = function (data, page, sort) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.queryCaseOutRecords,
            data: {
                caseNumber: data.caseNumber,
                outBatch: data.outBatch,
                outsourceId: data.outsourceId,
                personalName: data.personalName,
                idCard: data.idCard,
                outTimeMin: FilterService.dateRanageFormat(data.outTime).start,
                outTimeMax: FilterService.dateRanageFormat(data.outTime).end,
                outEndDateMin: FilterService.dateRanageFormat(data.outEndDate).start,
                outEndDateMax: FilterService.dateRanageFormat(data.outEndDate).end,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort
        });
    };
    /**
     * inBound查询
     */
    SynthesizeQueryService.prototype.inboundQuery = function (data, page, sort) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.inBoundQuery,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                area: data.area,
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                currentCollectorRealName: data.currentCollectorRealName,
                collectionStatus: data.collectionStatus,
                overduePeriod: data.overduePeriod,
                overdueDaysMin: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysMax: data.overdueDays ? data.overdueDays.max : '',
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 锁定催收员
     */
    SynthesizeQueryService.prototype.bindLockingCollector = function (caseId) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.bindLockingCollector,
            data: {
                caseId: caseId
            }
        });
    };
    /**
     * 短信发送查询
     */
    SynthesizeQueryService.prototype.queryMessageSendRecord = function (data, page, sort) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.queryMessageSendRecord,
            data: {
                caseNumber: data.caseNumber,
                mobileNo: data.mobileNo,
                messageStatus: data.messageStatus,
                operatorRealName: data.operatorRealName,
                createTimeMin: FilterService.dateRanageFormat(data.createTime).start,
                createTimeMax: FilterService.dateRanageFormat(data.createTime).end,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                personalName: data.personalName,
                idCard: data.idCard,
                partnerName: data.partnerName,
                bankName: data.bankName,
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 实时还款查询
     */
    SynthesizeQueryService.prototype.queryRepaymentRecord = function (data, page, sort) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.queryRepaymentRecord,
            data: {
                deptCode: data.deptCodes.length === 0 ? "" : data.deptCodes[data.deptCodes.length - 1],
                collectorId: data.collectorId,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 实时还款查询 -> 还款总金额查询
     */
    SynthesizeQueryService.prototype.getTotalRepayment = function (data) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.getTotalRepayment,
            data: {
                deptCode: data.deptCodes.length === 0 ? "" : data.deptCodes[data.deptCodes.length - 1],
                collectorId: data.collectorId
            }
        });
    };
    /**
     * 策略分案数据查询列表
     */
    SynthesizeQueryService.prototype.queryCaseDistributeData = function (data, page, sort) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.queryCaseDistributeData,
            data: {
                caseNumber: data.caseNumber,
                strategyName: data.strategyName,
                departmentType: data.departmentType,
                distributeDateMin: data.distributeDate.length ? FilterService.dateTimeFormat(data.distributeDate[0]) : '',
                distributeDateMax: data.distributeDate.length ? FilterService.dateTimeFormat(data.distributeDate[1]) : "",
                overdueDaysMin: data.overDueDays ? data.overDueDays.min : '',
                overdueDaysMax: data.overDueDays ? data.overDueDays.max : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : "",
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : "",
                overduePeriodMin: data.overduePeriodMin ? data.overduePeriodMin : '',
                overduePeriodMax: data.overduePeriodMax ? data.overduePeriodMax : '',
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 案件查询
     */
    SynthesizeQueryService.prototype.caseSearch = function (data, page, sort) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.caseSearch,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 案件导出
     */
    SynthesizeQueryService.prototype.caseSearchExportCase = function (data) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.caseSearchExportCase,
            data: data
        });
    };
    /**
     * 催记导出
     */
    SynthesizeQueryService.prototype.caseSearchExportFollow = function (data) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.caseSearchExportFollow,
            data: data
        });
    };
    /**
     * 查询案件状态
     */
    SynthesizeQueryService.prototype.getCaseCollectionStatus = function (data) {
        return this.netService.send({
            server: domainService.synthesizeQueryController.getCaseCollectionStatus,
            data: {
                caseType: data
            }
        });
    };
    SynthesizeQueryService.prototype.syncCollectionTypeToEs = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.syncCollectionTypeToEs,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], SynthesizeQueryService.prototype, "netService", void 0);
    return SynthesizeQueryService;
}());
export { SynthesizeQueryService };
